import { useMutation, useQueryClient } from 'react-query';
import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';
import { AddSolutionToOrgRequest } from '../_types/solution';

export default function useManageSolutions() {
  const queryClient = useQueryClient();

  const addSolutionToOrganization = useMutation(
    async ({ orgId, solutionId }: AddSolutionToOrgRequest) => {
      const url = `${baseApiUrl()}/admin-solution/v1/organizations/${orgId}/solutions/${solutionId}`;
      return await fetcher({
        method: 'post',
        url,
        body: { orgId, solutionId },
      });
    },
    {
      onSuccess: (_, { orgId }) => {
        // Invalidate and refetch organization solutions
        queryClient.invalidateQueries(['organizationSolutions', orgId]);
      },
    }
  );

  const removeSolutionFromOrganization = useMutation(
    async ({ orgId, solutionId }: AddSolutionToOrgRequest) => {
      const url = `${baseApiUrl()}/admin-solution/v1/organizations/${orgId}/solutions/${solutionId}`;
      return await fetcher({
        method: 'delete',
        url,
      });
    },
    {
      onSuccess: (_, { orgId }) => {
        // Invalidate and refetch organization solutions
        queryClient.invalidateQueries(['organizationSolutions', orgId]);
      },
    }
  );

  return {
    addSolutionToOrganization,
    removeSolutionFromOrganization,
  };
}
